// extracted by mini-css-extract-plugin
export default {"cards":"MenuRecipe_cards__5w8mo","description":"MenuRecipe_description__Ncs5p","ver":"MenuRecipe_ver__yQopv"};